import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// ✅ Import the centralized Server IP
import { SERVER_URL } from "../utils/api"; 
// ✅ Import ProfileView
import ProfileView from "./ProfileView"; 
import "../css/ridecard.css";

export default function RideCard({ ride }) {
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);

  if (!ride) return null; // Safety check

  // --- Driver & Avatar Logic ---
  const driver = ride?.postedBy || ride?.driver || {};
  
  // Neat image logic using your Central API IP
  const avatarSrc = driver.avatar 
    ? (driver.avatar.startsWith("http") ? driver.avatar : `${SERVER_URL}${driver.avatar}`)
    : "/default-avatar.png";

  // Format Date Safely
  const dateObj = new Date(ride.date || Date.now());
  const dateStr = dateObj.toLocaleDateString("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
  });

  const handleOpen = () => navigate(`/ride/${ride._id}`);
  
  const handleProfileClick = (e) => {
    e.stopPropagation(); // Prevents opening the ride details when clicking the avatar
    setShowProfile(true);
  };

  const isFull = (ride.seatsAvailable === 0);

  return (
    <>
      <div className="rc-card" onClick={handleOpen}>
        
        {/* Top Row: Driver Left | Price Right */}
        <div className="rc-main-row">
          
          {/* Driver Section */}
          <div className="rc-driver-wrapper" onClick={handleProfileClick}>
            <div className="rc-avatar-box">
              <img src={avatarSrc} className="rc-avatar" alt="driver" />
              {driver.verified && <div className="rc-verified-badge">✓</div>}
            </div>
            <div className="rc-driver-info">
              <h4 className="rc-name">{driver.name || "Member"}</h4>
              <div className="rc-rating">
                <span className="star">★</span>
                <span>{(driver.rating || 0).toFixed(1)}</span>
              </div>
            </div>
          </div>

          {/* Price Section */}
          <div className="rc-price-block">
            {/* ✅ Wrapped in a dedicated container to force spacing */}
            {ride.isFlexible && (
              <div className="rc-badge-container">
                <span className="rc-flexible-badge">✨ Flexible Match</span>
              </div>
            )}
            
            <div className="rc-price-value">
              <span className="currency">₹</span>
              <span className="amount">{ride.pricePerSeat}</span>
            </div>
          </div>
        </div>

        {/* Visual Route Timeline */}
        <div className="rc-route">
          <div className="rc-stop">
            <div className="rc-time">{ride.time}</div>
            <div className="rc-visual">
              <div className="rc-dot origin"></div>
              <div className="rc-line"></div>
            </div>
            <div className="rc-city">{ride.from}</div>
          </div>

          <div className="rc-stop">
            <div className="rc-time arrival">--:--</div>
            <div className="rc-visual">
              <div className="rc-dot dest"></div>
            </div>
            <div className="rc-city">{ride.to}</div>
          </div>
        </div>

        {/* Footer Details */}
        <div className="rc-footer">
          <div className="rc-detail-item">
            <span className="icon">📅</span>
            <span>{dateStr}</span>
          </div>
          
          <div className={`rc-detail-item seats-badge ${isFull ? "full" : "open"}`}>
            <span className="icon">💺</span>
            <span>{isFull ? "Full" : `${ride.seatsAvailable} seats left`}</span>
          </div>
        </div>
      </div>

      {/* ✅ Open our attractive ProfileView */}
      {showProfile && (
        <ProfileView 
          userId={driver._id || driver.id} 
          onClose={() => setShowProfile(false)} 
        />
      )}
    </>
  );
}